import {FormControl} from "@angular/forms";

export class MaskUtil {

  static validateCpfFormBuilder(control: FormControl): { [key: string]: boolean } | null{
    return MaskUtil.validar_cpf(control.value != undefined ? control.value : '') ? null : {cpfValid: true};
  }

  static validateCnpjFormBuilder(control: FormControl): { [key: string]: boolean } | null{
    return MaskUtil.validar_cnpj(control.value != undefined ? control.value : '') ? null : {cnpjValid: true};
  }

  static cepToMask(cep: string) {

    let mask;
    if (cep != null) {
      if (cep.length <= 8) {
        mask = cep.replace(/(.{5})/g, '$&' + '-');
      } else {
        mask = cep;
      }
    } else {
      mask = null;
    }
    return mask;
  }

  static maskToCep(mask: string) {
    let cep;
    if (mask != null) {
      cep = mask.replace(/-/gi, '');
    } else {
      cep = null;
    }
    return cep;
  }

  static telefoneToMask(telefone: string) {
    let mask;
    if (telefone != null && (telefone.length === 11 || telefone.length === 10)) {
      mask = '(' + telefone.substring(0, 2) + ') ' + telefone.substring(2, 7) + '-' + telefone.substring(7, telefone.length);
    } else if (telefone != null && (telefone.length === 10 || telefone.length === 9)) {
      mask = '(' + telefone.substring(0, 2) + ') ' + telefone.substring(2, 6) + '-' + telefone.substring(6, telefone.length);
    } else if (telefone != null && telefone.length > 10) {
      mask = telefone;
    } else if (telefone != null && (telefone.length === 9 || telefone.length === 8)) {
      mask = telefone.substring(0, 5) + '-' + telefone.substring(5, telefone.length);
    } else if (telefone != null && (telefone.length === 8 || telefone.length === 7)) {
      mask = telefone.substring(0, 4) + '-' + telefone.substring(4, telefone.length);
    } else {
      mask = null;
    }
    return mask;
  }

  static maskToTelefone(mask: string) {
    let telefone;
    if (mask != null) {
      telefone = mask.replace(/\(/gi, '').replace(/-/gi, '').replace(/\)/gi, '').replace(/\ /gi, '');
    } else {
      telefone = null;
    }
    return telefone;
  }

  /*
    MASCARA NUMERO DA ORDEM = 99-99/9999
  */
  static maskToOrdem(mask: string): number {
    let ordem = null;
    if (mask != null) {
      ordem = mask.replace(/\//gi, '');
      ordem = ordem.replace(/-/gi, '');
    }

    return ordem;
  }

  /*
    MASCARA DATA VALIDADE = YYYY/MM
  */
  static maskToData(mask: string) {
    let data = null;
    if (mask != null) {
      data = mask.replace(/\-/gi, '').replace(/\//gi, '');
    }

    return data;
  }

  /*
    MASCARA CPF = 999.999.999-99
  */
    static cpfToMask(cpf: string) {
      if (cpf) {
        // Remover caracteres não numéricos
        cpf = cpf.replace(/\D/g,'');

        // Adicionar zeros à direita até atingir 11 dígitos
        while (cpf.length < 11) cpf = cpf + '0';

        // Formatar o CPF
        return cpf.substring(0, 3) + '.' + cpf.substring(3, 6) + '.' + cpf.substring(6, 9) + '-' + cpf.substring(9);
      }
      return null;
    }

  static maskToCpf(mask: string) {
    let cpf;
    if (mask != null) {
      cpf = mask.replace(/\./gi, '');
      cpf = cpf.replace(/-/gi, '');
    } else {
      cpf = null;
    }
    return cpf;
  }

  /*
    MASCARA NIS = 999.99999.99-9
  */
  static nisToMask(nis: string) {
    let mask;
    if (nis != null && nis.length !== 0) {
      if (nis.length <= 11) {
        mask = nis.substring(0, 3) + '.' + nis.substring(3, 8) + '.' + nis.substring(8, 10) + nis.substring(10, nis.length);
        mask = mask.replace(/(.{12})/g, '$&' + '-');
      } else {
        mask = nis;
      }
    } else {
      mask = null;
    }
    return mask;
  }

  static maskToNis(mask: string) {
    let nis;
    if (mask != null) {
      nis = mask.replace(/\./gi, '');
      nis = nis.replace(/-/gi, '');
    } else {
      nis = null;
    }
    return nis;
  }

  static validar_nis(nis) {
    nis = nis.replace(/[^\d]+/g, '');
    if (nis === '') { return false; }

    if (nis.length !== 11 ||
      nis === '00000000000' ||
      nis === '11111111111' ||
      nis === '22222222222' ||
      nis === '33333333333' ||
      nis === '44444444444' ||
      nis === '55555555555' ||
      nis === '66666666666' ||
      nis === '77777777777' ||
      nis === '88888888888' ||
      nis === '99999999999') {
      return false;
    }

    // TODO: http://www.macoratti.net/alg_pis.htm

    return true;
  }

  static validar_cpf(cpf) {
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf === '') { return false; }
    if (cpf.length !== 11 ||
      cpf === '00000000000' ||
      cpf === '11111111111' ||
      cpf === '22222222222' ||
      cpf === '33333333333' ||
      cpf === '44444444444' ||
      cpf === '55555555555' ||
      cpf === '66666666666' ||
      cpf === '77777777777' ||
      cpf === '88888888888' ||
      cpf === '99999999999') {
      return false;
    }
    let add = 0;
    let i;
    for (i = 0; i < 9; i++) {
      // tslint:disable-next-line:radix
      add += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let rev = 11 - (add % 11);
    if (rev === 10 || rev === 11) {
      rev = 0;
    }
    // tslint:disable-next-line:radix
    if (rev !== parseInt(cpf.charAt(9))) {
      return false;
    }
    add = 0;
    for (i = 0; i < 10; i++) {
      // tslint:disable-next-line:radix
      add += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rev = 11 - (add % 11);
    if (rev === 10 || rev === 11) {
      rev = 0;
    }
    // tslint:disable-next-line:radix
    if (rev !== parseInt(cpf.charAt(10))) {
      return false;
    }
    return true;
  }

  static validar_cnpj(cnpj) {

    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj.length === 0) { return true; }

    if (cnpj.length !== 14) {
      return false;
    }

    if (cnpj === '00000000000000' ||
      cnpj === '11111111111111' ||
      cnpj === '22222222222222' ||
      cnpj === '33333333333333' ||
      cnpj === '44444444444444' ||
      cnpj === '55555555555555' ||
      cnpj === '66666666666666' ||
      cnpj === '77777777777777' ||
      cnpj === '88888888888888' ||
      cnpj === '99999999999999') {
      return false;
    }

    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    const digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    let i;
    for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) {
      return false;
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) {
      return false;
    }

    return true;
  }

  static validar_email(email: string) {
    const regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    return regex.test(email);

  }

  static validar_nome(nome: string) {
    const regex = /^([^0-9]*)$/;
    return regex.test(nome);
  }

  static validar_ramal(contato: string) {
    const regex = /^[0-9]{4}$/;

    return regex.test(contato);
  }

  /**
   * Formato DD/MM/YYYY
   *  */
  static validar_data(data) {

    data = data.replace(/\//gi, '');
    if (data === '') { return false; }

    if (data.length !== 2 ||
      data.substring(0, 2) > 31 ||
      data.substring(0, 2) < 1

    ) {

      return false;
    }

    return true;
  }

  static cnpjToMask(cnpj: string) {
    let mask;
    if (cnpj != null && cnpj.length !== 0) {
      if (cnpj.toString().length <= 14) {
        mask = cnpj.toString().replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3\/\$4\-\$5');
      } else {
        mask = cnpj;
      }
    } else {
      mask = null;
    }
    return mask;
  }

  static maskToCnpj(mask: string) {
    let cnpj;
    if (mask != null) {
      cnpj = mask.replace(/\./gi, '');
      cnpj = cnpj.replace(/-/gi, '');
      cnpj = cnpj.replace(/\//gi, '');
    } else {
      cnpj = null;
    }
    return cnpj;
  }

  static validar_dataValidade(data) {
    data = data.replace(/\//gi, '');
    if (data === '') { return false; }

    if (data.length !== 6 ||
      data.substring(4, 6) === '00' ||
      data.substring(4, 6) > 12 ||
      data.substring(0, 4) > 2500 ||
      data.substring(0, 4) < 1500) {
      return false;
    }

    return true;
  }

  static dataValidadeToMask(data: string) {
    let mask;
    if (data != null && data.length !== 0) {
      if (data.length <= 6) {
        mask = data.substring(0, 4) + '-' + data.substring(4, data.length);
      } else {
        mask = data;
      }
    } else {
      mask = null;
    }
    return mask;
  }

  static maskCPF()  {
    return [/[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/];
  }

  static maskCNPJ()  {
    return [/[0-9]/, /[0-9]/,'.', /[0-9]/, /[0-9]/, /[0-9]/,'.', /[0-9]/, /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/];
  }

  static novaMaskCPF() {
    return /[0-9]{3}[/.][0-9]{3}[/.][0-9]{3}[-][0-9]{2}/;
  }

  static maskNumProcesso()  {
    return [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, '.', /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  }

  static maskContatoTelefone() {
    return ['(', /[0-9]/, /[0-9]/, ')', ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  }

  static maskContatoCelular() {
    return ['(', /[0-9]/, /[0-9]/, ')', ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  }


  static maskOperacao() {
    return [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  }

  static maskDigito() {
    return [/[0-9]/];
  }

  // static maskRamal() {
  //   return [/[0-9]/, /[0-9]/, /[0-9]/], /[0-9]/];
  // }

  static maskData() {
    return [/[0-9]/, /[0-9]/];
  }

  static maskDataMesAno() {
    return [/[0-9]/, /[0-9]/,'/',/[0-9]/, /[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
  }

  static maskCEP() {
    return [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/];
  }

  static maskRG() {
    return [/[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/];
  }

  static maskAgencia() {
    return [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  }

  static maskConta() {
    return [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  }

  static maskCodBanco() {
    return [/[0-9]/, /[0-9]/, /[0-9]/];
  }

  static maskNumber() {
    return [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/ , /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  }

  static maskEmail(){
    return [/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i];
  }

  static maskToNumber(mask) {
    let retorno = '';

    for (let index = 0; index < mask.length; index++) {
      const element = mask.charCodeAt(index) as number;
      if (element >= 48 && element <= 57) {
        retorno += (mask.charAt(index));
      }
    }
    return retorno.toString();
  }

  static validar_telefone(mask, tamanho) {
    let retorno = '';

    for (let index = 0; index < mask.length; index++) {
      const element = mask.charCodeAt(index) as number;
      if (element >= 48 && element <= 57) {
        retorno += (mask.charAt(index));
      }
    }

    if (retorno.length === tamanho) {
      return true;
    }

    return false;

  }

  public cpfcnpjmask = function (rawValue) {
    var numbers = rawValue.match(/\d/g);
    var numberLength = 0;
    if (numbers) {
      numberLength = numbers.join('').length;
    }
    if (numberLength <= 11) {
      return [/[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/];
    } else {
      return [/[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/,  /[0-9]/, '-', /[0-9]/, /[0-9]/];
    }
  }

  static formatToUpperCaseAndOnlyDefaultCaracter(value: string, flEventInput: boolean = false): string {
    const pattern = /^[a-zA-Z0-9\s]*$/;
    const mapaAcentos: { [key: string]: string } = {
      'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u',
      'â': 'a', 'ê': 'e', 'î': 'i', 'ô': 'o', 'û': 'u',
      'à': 'a', 'è': 'e', 'ì': 'i', 'ò': 'o', 'ù': 'u',
      'ã': 'a', 'õ': 'o', 'ñ': 'n',
      'ç': 'c',
    };
    if (!pattern.test(value) && flEventInput) {
      value = value.replace(/[^a-zA-Z0-9\s]/g, '');
    } else {
      value = value.replace(/[^a-zA-Z0-9\s]/g, (match) => mapaAcentos[match]);
    }
    return value.toUpperCase();
  }
}
